import React from "react";
import Ic from "./Ic";
import { rad, sp } from "../../constants/styles";

// Metric card.
//
//   ic / l / v / cl  — icon name / label / value / accent color
//   grad             — optional [from, to] gradient. When supplied the
//                      whole card is filled with the gradient and the
//                      text/icon flip to white for contrast. Without it
//                      the card stays the default white surface (icon
//                      tinted with `cl`) — so existing callers are
//                      unaffected.
const MC = ({ ic, l, v, cl, h, onClick, grad }) => {
  const isGrad = Array.isArray(grad) && grad.length === 2;
  const txColor = isGrad ? "#fff" : h.tx;
  const labelColor = isGrad ? "rgba(255,255,255,0.85)" : (h.ts || h.sc);
  const iconTileBg = isGrad ? "rgba(255,255,255,0.22)" : `${cl}10`;
  const iconColor = isGrad ? "#fff" : cl;

  return <div onClick={onClick} style={{
    background: isGrad ? `linear-gradient(135deg, ${grad[0]} 0%, ${grad[1]} 100%)` : h.cd,
    border: isGrad ? "none" : `1px solid ${h.bd}`,
    borderRadius: rad.lg, padding: "16px 14px",
    cursor: onClick ? "pointer" : "default",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: isGrad ? `0 6px 18px ${grad[1]}55` : h.sh,
  }}
    onMouseOver={e => { if (onClick) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = isGrad ? `0 10px 26px ${grad[1]}66` : (h.s2 || h.sh); } }}
    onMouseOut={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = isGrad ? `0 6px 18px ${grad[1]}55` : h.sh; }}>
    <div style={{ width: 32, height: 32, borderRadius: rad.sm + 2, background: iconTileBg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: sp.sm }}><Ic n={ic} s={16} c={iconColor} /></div>
    <div style={{ color: txColor, fontWeight: 700, fontSize: 20, letterSpacing: "-0.3px", marginBottom: 2 }}>{v}</div>
    <div style={{ color: labelColor, fontSize: 11, fontWeight: 500 }}>{l}</div>
  </div>;
};

export default MC;
